<template>
  <modal
    name="edit-roles-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    height="auto"
    @closed="closeModal()"
    @before-open="getData"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Edit Role</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <div class="form-group modified-toggle-switch">
            <div class="form-group mt-3">
              <label for="InputText" class="quantity">Role Name</label>
              <input
                type="text"
                class="textInputField"
                placeholder="Enter role name(s)"
                v-model="role_name"
              />
            </div>
            <div class="">
              <p class="txt--xs txt--off-white">Permissions</p>
            </div>
            
            <div class="row my-2">
                <div class="col-md-12">
                  <div class="form-group d-flex align-items-center">
                    <app-toggle
                      :checked="access_permissions.all_property_access"
                      :label="'All Properties'"
                      @update:checked="getCheckedPermissions($event, 'all_property_access')"

                    >
                    </app-toggle>
                    <span class="text-white txt--ss opacity--50 ml-5" v-if="access_permissions.all_property_access">
                        <input type="checkbox" v-model="access_permissions.all_property_access_read"  value="1" class="cursor-pointer" checked disabled /> Read
                        <input type="checkbox" v-model="access_permissions.all_property_access_write"  value="1" class="cursor-pointer ml-3"/> Write
                    </span>
                  </div>
                </div>
            </div>
              
            <div class="row my-2">
              <div class="col-md-12">
                <div class="form-group d-flex align-items-center"> 
                  <app-toggle :checked="access_permissions.report_access" :label="'Reports'"
                    @update:checked="getCheckedPermissions($event, 'report_access')"
                  
                  >
                  </app-toggle>
                  <span class="text-white txt--ss opacity--50 ml-5" v-if="access_permissions.report_access">
                      <input type="checkbox" v-model="access_permissions.report_access_read" value="1" class="cursor-pointer" checked disabled /> Read
                      <input type="checkbox" v-model="access_permissions.report_access_write" value="1" class="cursor-pointer ml-3"/> Write
                  </span>
                </div>                  
              </div> 
            </div>

            <div class="row my-2">
              <div class="col-md-12">
                <div class="form-group d-flex align-items-center">               
                    <app-toggle
                      :checked="access_permissions.gate_access"
                      :label="'Gates'"
                      @update:checked="getCheckedPermissions($event, 'gate_access')"

                    >
                    </app-toggle>
                    <span class="text-white txt--ss opacity--50 ml-5" v-if="access_permissions.gate_access">
                        <input type="checkbox"  v-model="access_permissions.gate_access_read" value="1" class="cursor-pointer" checked disabled /> Read
                        <input type="checkbox"  v-model="access_permissions.gate_access_write" value="1" class="cursor-pointer ml-3"/> Write
                    </span>                     
                </div>
              </div>
            </div>

            <div class="row my-2">
              <div class="col-md-12">
                <div class="form-group d-flex align-items-center">               
                    <app-toggle
                      :checked="access_permissions.session_access"
                      :label="'Sessions'"
                      @update:checked="getCheckedPermissions($event, 'session_access')"

                    >
                    </app-toggle>
                    <span class="text-white txt--ss opacity--50 ml-5" v-if="access_permissions.session_access">
                        <input type="checkbox"  v-model="access_permissions.session_access_read" value="1" class="cursor-pointer" checked disabled /> Read
                        <input type="checkbox"  v-model="access_permissions.session_access_write" value="1" class="cursor-pointer ml-3"/> Write
                    </span>                     
                </div>
              </div>
            </div>

            <div class="row my-2">
              <div class="col-md-12">
                <div class="form-group d-flex align-items-center">               
                    <app-toggle
                      :checked="access_permissions.validation_access"
                      :label="'Validations'"
                      @update:checked="getCheckedPermissions($event, 'validation_access')"

                    >
                    </app-toggle>
                    <span class="text-white txt--ss opacity--50 ml-5" v-if="access_permissions.validation_access">
                        <input type="checkbox"  v-model="access_permissions.validation_access_read" value="1" class="cursor-pointer" checked disabled /> Read
                        <input type="checkbox"  v-model="access_permissions.validation_access_write" value="1" class="cursor-pointer ml-3"/> Write
                    </span>                     
                </div>
              </div>
            </div>

            <div class="row my-2">
              <div class="col-md-12">
                <div class="form-group d-flex align-items-center">               
                    <app-toggle
                      :checked="access_permissions.permit_access"
                      :label="'Permits'"
                      @update:checked="getCheckedPermissions($event, 'permit_access')"

                    >
                    </app-toggle>
                    <span class="text-white txt--ss opacity--50 ml-5" v-if="access_permissions.permit_access">
                        <input type="checkbox"  v-model="access_permissions.permit_access_read" value="1" class="cursor-pointer" checked disabled /> Read
                        <input type="checkbox"  v-model="access_permissions.permit_access_write" value="1" class="cursor-pointer ml-3"/> Write
                    </span>
                </div>
                <!-- <div class="form__group">
                  <label class="txt--xs txt--off-white mb-2">All Permits</label>
                  <app-toggle
                    :checked="access_permissions.all_property_access"
                    :label="'All Permits'"
                    @update:checked="getCheckedPermissions($event, 'all_property_access')">
                  </app-toggle>
                  <model-list-select v-if="permit_list.length > 0" :list="permit_list" v-model="form.permit_id"
                    option-value="permit_id" option-text="permit_name" placeholder="Select Permit"
                    class="custom-vue-select">
                  </model-list-select>
                </div> -->
              </div>
              <div class="col-md-12 form__group mb-4" v-if="access_permissions.permit_access">
                <multi-list-select
                  :list="permit_list"
                  option-value="permit_id"
                  option-text="permit_name"
                  :selected-items="permit_selected_list"
                  placeholder="Select permit(s)"
                  @select="selectPermits"
                  class="custom-vue-select"
                  v-tooltip="'Leave empty to allow all permits'"
                >
                </multi-list-select>
              </div>
            </div>

            <div class="row my-2">
              <div class="col-md-12">
                <div class="form-group d-flex align-items-center">               
                    <app-toggle
                      :checked="access_permissions.invitation_access"
                      :label="'Invitations'"
                      @update:checked="getCheckedPermissions($event, 'invitation_access')"

                    >
                    </app-toggle>
                    <span class="text-white txt--ss opacity--50 ml-5" v-if="access_permissions.invitation_access">
                        <input type="checkbox"  v-model="access_permissions.invitation_access_read" value="1" class="cursor-pointer" checked disabled /> Read
                        <input type="checkbox"  v-model="access_permissions.invitation_access_write" value="1" class="cursor-pointer ml-3"/> Write
                    </span>                     
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center flex-wrap mt-4">
        <ButtonWithSpinner class="button button--primary button--sm mr-3"
        :disabled="create_button.disabled"
        :loading="create_button.loading"
        :success="create_button.success"
        @click="updateRole"
        >
          Update</ButtonWithSpinner
        >
        <button
          type="button"
          class="button button--outline button--sm"
          @click="closeModal()"
        >
          Cancel
        </button>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>
<script>
import "vue-search-select/dist/VueSearchSelect.css";
import ButtonWithSpinner from "@/components/Button";
import Toggle from "@/components/toggle";
import { MultiListSelect } from "vue-search-select";
export default {
  name: "EditRole",
  components: {
    AppToggle: Toggle,
    // ModelListSelect,
    // ModelSelect,
    ButtonWithSpinner,
    MultiListSelect,
  },
  data() {
    return {
      role_name:'',
      role_id:'',
      access_permissions:{
        all_property_access:false,       
        property_access_list:[],
        report_access: false, 
        gate_access : false,
        //audit_access: false,
        permit_access: false,
        permit_access_list: [],
        session_access: false,
        invitation_access: false,
        validation_access: false,
      
        all_property_access_read:   true,
        all_property_access_write:  false,
        report_access_read:         true,
        report_access_write:        false,
        gate_access_read:           true,
        gate_access_write:          false,
        permit_access_read:         true,
        permit_access_write:        false,
        session_access_read:        true,
        session_access_write:       false,
        invitation_access_read:     true,
        invitation_access_write:    false,
        validation_access_read:     true,
        validation_access_write:    false,
      },
      status:true,
      property_list: [],
      create_button: {
        disabled: false,
        loading: false,
        success: false,
      },
      permit_list: [],
      permit_selected_list: [],
    };
  },

  created() {},
  methods: {
    getPermits(access_list) {
      this.axios
        .post(window.hostname + "/api/auth/permit/list", {
          commercial: 1,
          page: 1,
          limit: 500,
          all: 1,
          property_id: this.property_id,
        })
        .then((res) => {
          if (res.data.status) {
            this.permit_list = res.data.data.permit_list ? res.data.data.permit_list : [];
          } else {
            this.permit_list = [];
          }
          this.permit_selected_list = this.permit_list.filter(permit => access_list.includes(permit.permit_id))
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectPermits(items) {
      this.permit_selected_list = items;
      this.access_permissions.permit_access_list = items.map(item => item.permit_id);
    },
    getData(e){
        this.role_id = e.params.role.id;
        this.role_name = e.params.role.name;

        this.access_permissions.property_access_list = e.params.role.property_access_list ? e.params.role.property_access_list : [];
        this.access_permissions.permit_access_list = e.params.role.permit_access_list ? e.params.role.permit_access_list : [];

        this.access_permissions.all_property_access = e.params.role.all_property_access ? e.params.role.all_property_access:false;
        this.access_permissions.report_access = e.params.role.report_access ? e.params.role.report_access:false;
        this.access_permissions.gate_access =  e.params.role.gate_access ? e.params.role.gate_access:false;
        this.access_permissions.permit_access =  e.params.role.permit_access ? e.params.role.permit_access:false;
        this.access_permissions.session_access =  e.params.role.session_access ? e.params.role.session_access:false;
        this.access_permissions.invitation_access = e.params.role.invitation_access ? e.params.role.invitation_access:false;
        this.access_permissions.validation_access = e.params.role.validation_access ? e.params.role.validation_access:false;

        this.access_permissions.all_property_access_read = e.params.role.all_property_access_read ? e.params.role.all_property_access_read:true;
        this.access_permissions.all_property_access_write = e.params.role.all_property_access_write ? e.params.role.all_property_access_write:false;
        this.access_permissions.report_access_read = e.params.role.report_access_read ? e.params.role.report_access_read:true;
        this.access_permissions.report_access_write = e.params.role.report_access_write ? e.params.role.report_access_write:false;
        this.access_permissions.gate_access_read = e.params.role.gate_access_read ? e.params.role.gate_access_read:true;
        this.access_permissions.gate_access_write = e.params.role.gate_access_write ? e.params.role.gate_access_write:false;
        this.access_permissions.permit_access_read = e.params.role.permit_access_read ? e.params.role.permit_access_read:true;
        this.access_permissions.permit_access_write = e.params.role.permit_access_write ? e.params.role.permit_access_write:false;
        this.access_permissions.session_access_read = e.params.role.session_access_read ? e.params.role.session_access_read:true;
        this.access_permissions.session_access_write = e.params.role.session_access_write ? e.params.role.session_access_write:false;
        this.access_permissions.invitation_access_read = e.params.role.invitation_access_read ? e.params.role.invitation_access_read:true;
        this.access_permissions.invitation_access_write = e.params.role.invitation_access_write ? e.params.role.invitation_access_write:false;
        this.access_permissions.validation_access_read = e.params.role.validation_access_read ? e.params.role.validation_access_read:true;
        this.access_permissions.validation_access_write = e.params.role.validation_access_write ? e.params.role.validation_access_write:false;

        this.getPermits(e.params.role.permit_access_list);
    },
    getCheckedPermissions(checked,type){
      if(type == 'all_property_access'){
        this.access_permissions.all_property_access = checked;
      }
      if(type == 'report_access'){
        this.access_permissions.report_access = checked;
      }
      if(type == 'gate_access'){
        this.access_permissions.gate_access=checked;
      }
      if(type == 'session_access'){
        this.access_permissions.session_access=checked;
      }
      if(type == 'validation_access'){
        this.access_permissions.validation_access=checked;
      }
      if(type == 'invitation_access'){
        this.access_permissions.invitation_access=checked;
      }
      if(type == 'permit_access'){
        this.access_permissions.permit_access=checked;
      }
      // if(type == 'all_permit_access'){
      //   this.access_permissions.permit_access_list = checked;
      // }
    },
    closeModal() {
      this.reset();
      this.$modal.hide("edit-roles-modal");
    },
    updateRole(){
      if(this.role_name == ''){
          this.$toasted.show('Role name is required',{
              icon : 'times-circle',
              className: 'error-class'
          });    
          return false;       
      }

      if(this.access_permissions.all_property_access==false){
        this.access_permissions.all_property_access_read=false;
        this.access_permissions.all_property_access_write=false;
      }

      if(this.access_permissions.report_access==false){
        this.access_permissions.report_access_read=false;
        this.access_permissions.report_access_write=false;
      }
      
      if(this.access_permissions.gate_access==false){
        this.access_permissions.gate_access_read=false;
        this.access_permissions.gate_access_write=false;
      }

      if(this.access_permissions.validation_access==false){
        this.access_permissions.validation_access_read=false;
        this.access_permissions.validation_access_write=false;
      }

      if(this.access_permissions.invitation_access==false){
        this.access_permissions.invitation_access_read=false;
        this.access_permissions.invitation_access_write=false;
      }

      if(this.access_permissions.permit_access==false){
        this.access_permissions.permit_access_read=false;
        this.access_permissions.permit_access_write=false;
      }

      if(this.access_permissions.session_access==false){
        this.access_permissions.session_access_read=false;
        this.access_permissions.session_access_write=false;
      }
      
      this.create_button.loading = true;
      this.create_button.disabled = true;
      this.create_button.success = false;

      this.axios
        .post(window.hostname + "api/auth/role/update", {
          id:this.role_id,  
          role:this.role_name,
          //accesss
          all_property_access:this.access_permissions.all_property_access,
          report_access:this.access_permissions.report_access,
          gate_access:this.access_permissions.gate_access,
          permit_access:this.access_permissions.permit_access,
          permit_access_list:this.access_permissions.permit_access_list,
          session_access:this.access_permissions.session_access,
          validation_access:this.access_permissions.validation_access,
          invitation_access:this.access_permissions.invitation_access,
          //read write
          all_property_access_read:this.access_permissions.all_property_access_read,
          all_property_access_write:this.access_permissions.all_property_access_write,
          report_access_read:this.access_permissions.report_access_read,
          report_access_write:this.access_permissions.report_access_write,
          gate_access_read:this.access_permissions.gate_access_read,
          gate_access_write:this.access_permissions.gate_access_write,
          permit_access_read:this.access_permissions.permit_access_read,
          permit_access_write:this.access_permissions.permit_access_write,
          session_access_read:this.access_permissions.session_access_read,
          session_access_write:this.access_permissions.session_access_write,
          invitation_access_read:this.access_permissions.invitation_access_read,
          invitation_access_write:this.access_permissions.invitation_access_write,
          validation_access_read:this.access_permissions.validation_access_read,
          validation_access_write:this.access_permissions.validation_access_write,
        }).then((res)=>{
          if(res.data.status){
            this.$toasted.show(res.data.message, {
                icon: "check-circle",
                className: "success-class",
            });
            this.$emit("update_role");
            this.create_button.disabled = false;
            this.create_button.success = true;
            this.create_button.loading = false;
            this.reset();
            this.closeModal();
          }
          else{
            this.create_button.disabled = false;
            this.create_button.success = false;
            this.create_button.loading = false;
            this.$toasted.show(res.data.message,{
                icon : 'times-circle',
                className: 'error-class'
            });            
          }
        })
        

    },
    reset() {
        this.access_permissions.all_property_access =false;
        this.access_permissions.property_access_list =[];
        this.access_permissions.report_access =false;
        this.access_permissions.gate_access =false;
        this.access_permissions.permit_access =false;
        this.access_permissions.permit_access_list = [];
        this.access_permissions.session_access = false;
        this.access_permissions.invitation_access =false;
        this.access_permissions.validation_access =false;

        this.access_permissions.all_property_access_read =true;
        this.access_permissions.all_property_access_write =false;
        this.access_permissions.report_access_read =true;
        this.access_permissions.report_access_write =false;
        this.access_permissions.gate_access_read =true;
        this.access_permissions.gate_access_write =false;
        this.access_permissions.permit_access_read =true;
        this.access_permissions.permit_access_write =false;
        this.access_permissions.session_access_read =true;
        this.access_permissions.session_access_write =false;
        this.access_permissions.invitation_access_read =true;
        this.access_permissions.invitation_access_write =false;
        this.access_permissions.validation_access_read =true;
        this.access_permissions.validation_access_write =false;

        this.permit_selected_list = [];
        this.create_button.disabled =false;
        this.create_button.loading  =false;
        this.create_button.success =false;
    },
  },
};
</script>

<style scoped>
.modified-toggle-switch p {
  flex-basis: 50%;
}

.modified-toggle-switch app-toggle {
  flex-basis: 50%;
}
input[type="text"] {
  background: transparent;
  outline: none;
  border-radius: 22px;
  border: 1px solid #535353;
}
.quantity {
  color: #848484;
  font-size: 10px;
}
</style>